import Alpine from 'alpinejs'
import { create } from '@lottiefiles/lottie-interactivity'
import tippy from 'tippy.js'

Alpine.start()

if (document.getElementById('flagAnim') || false) {
  create({
    mode: 'scroll',
    player: '#flagAnim',
    actions: [
      {
        visibility: [0.3, 1.0],
        type: 'play',
        frames: [0, 61]
      }
    ]
  })
}

const tooltips = document.querySelectorAll('sup.tooltip')
tooltips.forEach(tooltip => {
  const id = tooltip.getAttribute('id')
  tippy(`#${id}>a`, {
    content (ref) {
      const id = ref.getAttribute('data-content')
      const template = document.getElementById(id)
      return template.innerHTML
    },
    trigger: 'click',
    interactive: true,
    allowHTML: true,
    theme: 'openfuture',
    appendTo: document.body,
    placement: 'bottom',
    animation: 'shift-away-subtle'
  })
})
// console.log('🤠')
